<template>
  <nav class="navbar" :class="{ scrolled: isScrolled }">
    <router-link to="/" class="nav-logo" @click="closeMenu">
      <img src="@/assets/logo.png" alt="Venom Gym" class="logo-img" />
      <div class="logo-text">
        <span class="logo-venom">VENOM</span>
        <span class="logo-gym">GYM</span>
      </div>
    </router-link>

    <ul :class="['nav-links', { active: isOpen }]">
      <li><router-link to="/" @click="closeMenu">Home</router-link></li>
      <li><router-link to="/about" @click="closeMenu">About</router-link></li>
      <li>
        <router-link to="/contact" @click="closeMenu">Contact</router-link>
      </li>
      <li class="nav-cta-wrap">
        <router-link to="/contact" class="nav-cta" @click="closeMenu"
          >Join Now</router-link
        >
      </li>
    </ul>

    <button
      class="hamburger"
      :class="{ open: isOpen }"
      @click="toggleMenu"
      aria-label="Menu"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  </nav>
</template>

<script>
export default {
  name: "NavbarView",
  data() {
    return { isOpen: false, isScrolled: false };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    closeMenu() {
      this.isOpen = false;
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 60;
    },
  },
};
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  padding: 16px 5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.4s ease;
  background: transparent;
}

.navbar.scrolled {
  background: rgba(5, 5, 5, 0.97);
  backdrop-filter: blur(20px);
  padding: 10px 5%;
  border-bottom: 1px solid rgba(204, 0, 0, 0.35);
  box-shadow: 0 4px 40px rgba(204, 0, 0, 0.12);
}

/* Logo */
.nav-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}
.logo-img {
  height: 48px;
  filter: drop-shadow(0 0 12px rgba(204, 0, 0, 0.8));
  transition: filter 0.3s;
}
.nav-logo:hover .logo-img {
  filter: drop-shadow(0 0 22px rgba(255, 30, 30, 1));
}
.logo-text {
  display: flex;
  flex-direction: column;
  line-height: 1;
}
.logo-venom {
  font-family: "Black Ops One", cursive;
  font-size: 1.3rem;
  color: #fff;
  letter-spacing: 2px;
}
.logo-gym {
  font-family: "Bebas Neue", cursive;
  font-size: 0.85rem;
  color: var(--red);
  letter-spacing: 5px;
}

/* Links */
.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  gap: 36px;
}

.nav-links a {
  color: rgba(240, 240, 240, 0.7);
  text-decoration: none;
  font-family: "Rajdhani", sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  position: relative;
  transition: color 0.3s;
}
.nav-links a::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--red);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}
.nav-links a:hover,
.nav-links a.router-link-exact-active {
  color: #fff;
}
.nav-links a:hover::after,
.nav-links a.router-link-exact-active::after {
  transform: scaleX(1);
}

/* CTA Button */
.nav-cta {
  background: var(--red) !important;
  color: #fff !important;
  padding: 9px 22px;
  font-family: "Bebas Neue", cursive !important;
  font-size: 1rem !important;
  letter-spacing: 2px;
  clip-path: polygon(6px 0%, 100% 0%, calc(100% - 6px) 100%, 0% 100%);
  transition: all 0.3s ease;
  border-bottom: none !important;
}
.nav-cta::after {
  display: none !important;
}
.nav-cta:hover {
  background: var(--red-glow) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 24px rgba(204, 0, 0, 0.55) !important;
}

/* Hamburger */
.hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}
.hamburger span {
  display: block;
  width: 26px;
  height: 2px;
  background: var(--white);
  border-radius: 2px;
  transition: all 0.35s cubic-bezier(0.77, 0, 0.18, 1);
}
.hamburger.open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}
.hamburger.open span:nth-child(2) {
  opacity: 0;
  transform: scaleX(0);
}
.hamburger.open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* Responsive */
@media (max-width: 900px) {
  .hamburger {
    display: flex;
  }

  .nav-links {
    position: fixed;
    top: 0;
    right: 0;
    width: min(320px, 80vw);
    height: 100vh;
    background: rgba(8, 8, 8, 0.98);
    backdrop-filter: blur(30px);
    flex-direction: column;
    gap: 0;
    padding: 100px 0 40px;
    border-left: 1px solid rgba(204, 0, 0, 0.25);
    transform: translateX(100%);
    transition: transform 0.4s cubic-bezier(0.77, 0, 0.18, 1);
    box-shadow: -10px 0 60px rgba(0, 0, 0, 0.5);
  }
  .nav-links.active {
    transform: translateX(0);
  }

  .nav-links li {
    width: 100%;
  }
  .nav-links a {
    display: block;
    padding: 16px 36px;
    font-size: 1.1rem;
    color: rgba(240, 240, 240, 0.8);
    border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  }
  .nav-links a::after {
    bottom: 0;
    height: 2px;
  }

  .nav-cta-wrap {
    margin-top: 20px;
    padding: 0 36px;
  }
  .nav-cta {
    display: block;
    text-align: center;
    padding: 14px 0 !important;
    clip-path: none !important;
    border-radius: 6px;
  }
}
</style>
